import React from 'react';
import { useSelector } from 'react-redux';
import { ListHorizontal } from 'ui/components';
import { SkeletonText } from 'ui/components/skeleton';
import { formatDate } from 'utilities/common';

export const InformationDelivery = ({ data }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['SalesOrder.Show']
  );

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  return (
    <section className="border rounded-2 p-3 pt-2 mb-3" id="order">
      <div className="fw-semibold py-2 border-bottom" style={{ fontSize: 13 }}>
        {StateLoading ? (
          <div style={{ width: 250 }}>
            <SkeletonText count={1} />
          </div>
        ) : (
          'Informasi Pengiriman'
        )}
      </div>
      <div className="row pt-2">
        {StateLoading ? (
          dummy?.map((d, i) => (
            <div className="col-12" key={i}>
              <ListHorizontal
                title={<SkeletonText count={1} />}
                content={<SkeletonText count={1} />}
              />
            </div>
          ))
        ) : (
          <>
            <ListHorizontal title="Kode" content={data?.code} />
            {data?.ref_code && <ListHorizontal
              title="Customer Reference Number"
              content={data?.ref_code}
            />}
            <ListHorizontal
              title="Tanggal Pengiriman"
              content={formatDate(data?.shipping_date, 'DD/MM/YYYY')}
            />
            <ListHorizontal
              title="Customer"
              content={data?.customer?.name}
            />
            <ListHorizontal
              title="Fulfillment"
              content={
                <span className={`badge status-${data?.fulfillment_status}-lt ms-auto `}>
                  {data?.fulfillment_status?.replace('_', ' ')?.replace('voided', 'void')}
                </span>
              }
            />
            <ListHorizontal title="Total Weight" content={
              <span>{(data?.total_weight / 1000)} Kg</span>
            } />
            <ListHorizontal
              title="Catatan"
              className="border-bottom-0"
              content={data?.note || '-'}
            />
          </>
        )}
      </div>
    </section>
  );
};
